
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
.language-wrapper {
  font-family: var(--slh-default-font-family, "Open Sans");
  font-size: var(--slh-base-xs-font-size, 14px);
  font-weight: var(--slh-base-bold-font-weight, 700);
  line-height: var(--slh-base-xxs-line-height, 24px);
  text-transform: uppercase;
  display: inline-block;
  padding-left: 4px;
  padding-right: 4px;
  background: var(--slh-color-neutral-shade-40, #C0C8D8);
  color: var(--slh-color-neutral-shade-00, #FFFFFF);
  border-radius: 4px;
}
`;
